import { render, staticRenderFns } from "./MarginCarousel.vue?vue&type=template&id=0705531f&scoped=true&"
import script from "./MarginCarousel.vue?vue&type=script&lang=js&"
export * from "./MarginCarousel.vue?vue&type=script&lang=js&"
import style0 from "./MarginCarousel.vue?vue&type=style&index=0&id=0705531f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0705531f",
  null
  
)

export default component.exports